import { Navigate, RouteObject, useNavigate, useParams } from "react-router-dom";
import { TopBarPageContainer } from "../../components/PageContainer";
import ProductListManagerContainer from "./ProductListManagerContainer";
import OpwContextProviderWrapper from "./OpwContextProviderWrapper";
import { TopBarActions } from "./list";
import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { useState } from "react";
import { AoType, tabTypes } from "./types";

export const PRODUCT_LIST_MANAGER_ROUTES: RouteObject[] = [
  {
    element: <PermissionedRoutes requiredPermissions={["indigo.view_opening_products"]} />,
    children: [
      {
        index: true,
        element: <Navigate to="/product_list_manager/consumer" />,
      },
      {
        path: ":type",
        lazy: async () => {
          const { List } = await import("./list");
          const Component = () => (
            <ProductListManagerContainer>
              <OpwContextProviderWrapper>
                <TopBarPageContainer
                  title="Product list manager"
                  maxWidth="1500px"
                  action={<TopBarActions />}
                >
                  <List />
                </TopBarPageContainer>
              </OpwContextProviderWrapper>
            </ProductListManagerContainer>
          );
          return { Component };
        },
      },
      {
        path: "add/:type",
        lazy: async () => {
          const { Add } = await import("./add");
          const Component = () => {
            const navigate = useNavigate();
            const [pageTitle, setPageTitle] = useState("New product");
            const { type } = useParams();
            if (type && !tabTypes.includes(type as AoType)) {
              return <Navigate to="/product_list_manager" />;
            }
            return (
              <ProductListManagerContainer>
                <OpwContextProviderWrapper>
                  <TopBarPageContainer
                    title={pageTitle}
                    maxWidth="1500px"
                    backIconOnClick={() => {
                      navigate(`/product_list_manager/${type}`);
                    }}
                  >
                    <Add setPageTitle={setPageTitle} />
                  </TopBarPageContainer>
                </OpwContextProviderWrapper>
              </ProductListManagerContainer>
            );
          };
          return { Component };
        },
      },
      {
        path: "edit/:type/:id",
        lazy: async () => {
          const { Edit } = await import("./add");
          const Component = () => {
            const navigate = useNavigate();
            const [pageTitle, setPageTitle] = useState("Edit product");
            const { type } = useParams();
            if (type && !tabTypes.includes(type as AoType)) {
              return <Navigate to="/product_list_manager" />;
            }
            return (
              <ProductListManagerContainer>
                <OpwContextProviderWrapper>
                  <TopBarPageContainer
                    title={pageTitle}
                    maxWidth="1500px"
                    backIconOnClick={() => {
                      navigate(`/product_list_manager/${type}`);
                    }}
                  >
                    <Edit setPageTitle={setPageTitle} />
                  </TopBarPageContainer>
                </OpwContextProviderWrapper>
              </ProductListManagerContainer>
            );
          };
          return { Component };
        },
      },
      {
        path: "bundle/:type/:id?",
        lazy: async () => {
          const { DetailBundle } = await import("./bundle_detail");
          const Component = () => {
            const navigate = useNavigate();
            const [pageTitle, setPageTitle] = useState("Edit product");
            const { type } = useParams();
            if (!type || !/^(consumer|business)$/.test(type)) {
              return <Navigate to="/product_list_manager" />;
            }
            return (
              <ProductListManagerContainer>
                <OpwContextProviderWrapper>
                  <TopBarPageContainer
                    title={pageTitle}
                    maxWidth="1500px"
                    backIconOnClick={() => {
                      navigate(`/product_list_manager/${type}`);
                    }}
                  >
                    <DetailBundle setPageTitle={setPageTitle} />
                  </TopBarPageContainer>
                </OpwContextProviderWrapper>
              </ProductListManagerContainer>
            );
          };
          return { Component };
        },
      },
    ],
  },
];
